module.exports = __webpack_public_path__ + "media/vo-01-06.e6f46e91.mp3";